import { Button } from '@aws-amplify/ui-react';
import React, { useEffect, useState } from 'react';
import { FaCheck, FaCopy } from 'react-icons/fa';
import './CopyToClipboard.scss';

interface CopyToClipboardProps {
  value: string;
  title?: string;
}

/**
 * Reusable component for copying text to clipboard
 * Shows a clipboard icon button that copies the provided value when clicked
 * Displays a checkmark for 3 seconds after successful copy
 */
export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  value,
  title = 'Copy to clipboard'
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [copied]);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
  };

  return (
    <span className="copy-to-clipboard-wrapper">
      <Button
        size="small"
        variation="link"
        onClick={handleCopy}
        className={`copy-to-clipboard-button ${copied ? 'copy-to-clipboard-button--copied' : ''}`}
        title={copied ? 'Copied!' : title}
      >
        {copied ? <FaCheck size={11} /> : <FaCopy size={11} />}
      </Button>
      {copied && <span className="copy-to-clipboard-toast">Copied</span>}
    </span>
  );
};
